// src/pages/BlogDetail.jsx
import { useParams } from "react-router-dom";
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import BlogDetailsSection from "../components/Blog/BlogDetailsSection";
import { blogPosts } from "../data/blogData";

const BlogDetail = () => {
  const { slug } = useParams();

  const blog = blogPosts.find((b) => b.slug === slug);

  return (
    <Layout>
      <Breadcrumb
        title={blog.title}
        parent={{ name: "Trang chủ", path: "/" }}
        parent2={{ name: "Bài viết", path: "/bai-viet" }}
      />

      <BlogDetailsSection post={blog} />
    </Layout>
  );
};

export default BlogDetail;
